import {serializeFilters} from 'nutshell-core';
import type {ReportGap, FilterObject} from 'nutshell-core/types';

export type FormEngagementChartParams = {
    gap: ReportGap;
    formId?: string;
    formType?: number;
};

export type FormEngagementReportPostParams = {
    filter: any;
    gap: ReportGap;
    formId: string | null | undefined;
};

export function getEngagementReportPostParams(
    reportParams: FormEngagementChartParams,
    filters: FilterObject[]
): FormEngagementReportPostParams {
    const {gap, formId, formType} = reportParams;

    return {
        filter: serializeFilters(filters),
        gap,
        formId,
        // @ts-expect-error
        formType,
    };
}
